import http from './http';
import Cart from './models/Cart';
import DropShip from './models/DropShip';
import CountryAndStates from './models/CountryAndStates';
import OrderResponse from './models/OrderResponse';
import DropShipUps from './models/DropshipUps';

export class CartAPI {
	static ADD_TO_CART_ENDPOINT = 'cart/AddToCart';
	static UPDATE_TO_CART_ENDPOINT = 'cart/UpdateCart';
	static VALIDATE_DROP_SHIP_ENDPOINT = 'dropship/ValidateAddress';
	static ADD_DROP_SHIP_ENDPOINT = 'dropship/AddDropShip';
	static UPDATE_DROP_SHIP_ENDPOINT = 'dropship/UpdateDropShip';
	static COUNTRIES_AND_STATES = 'dropship/GetCountriesAndStates';
	static SUBMIT_CART_ENDPOINT = 'cart/Submit';

	addToCart(items) {
		const cartItems = items.map(item => new Cart().serialize(item));

		return http
			.post(`${CartAPI.ADD_TO_CART_ENDPOINT}`, cartItems)
			.then(result => new Cart(result));
	}

	updateCart(items) {
		const cartItems = items.map(item => new Cart().serialize(item));

		return http
			.post(`${CartAPI.UPDATE_TO_CART_ENDPOINT}`, cartItems)
			.then(result => new Cart(result));
	}

	addDropShipAddress(address, item) {
		const drop_ship = new DropShip().serialize(address);
		item.drop_ship_address = address;
		const cartItem = new Cart().serialize(item);

		return http
			.post(`${CartAPI.ADD_DROP_SHIP_ENDPOINT}`, {
				Address: drop_ship,
				Item: cartItem,
			})
			.then(result => new Cart(result));
	}

	updateDropShipAddress(address, item) {
		const drop_ship = new DropShip().serialize(address);
		item.drop_ship_address = address;
		const cartItem = new Cart().serialize(item);

		return http
			.post(`${CartAPI.UPDATE_DROP_SHIP_ENDPOINT}`, {
				Address: drop_ship,
				Item: cartItem,
			})
			.then(result => new Cart(result));
	}

	validateDropShipAddress(address) {
		return http
			.post(`${CartAPI.VALIDATE_DROP_SHIP_ENDPOINT}`, {
				Address1: address.address1,
				Address2: address.address2,
				City: address.city,
				StateAbbreviation: address.stateAbbreviation,
				Country: address.country,
				Zip: address.zip,
			})
			.then(result => new DropShipUps(result));
	}

	getCountriesAndStates() {
		return http
			.get(CartAPI.COUNTRIES_AND_STATES)
			.then(result => result.map(country => new CountryAndStates(country)));
	}

	submitOrder(Current) {
		return http
			.post(CartAPI.SUBMIT_CART_ENDPOINT, { Current })
			.then(result => new OrderResponse(result));
	}
}

export default new CartAPI();



// WEBPACK FOOTER //
// ./src/api/cart.js